import React, { useState, useEffect, useCallback } from 'react';
import { Select } from 'antd';
import { debounce } from 'lodash';
import { apiGetCategory } from '@services/ManageDevices/DeviceServices';

const { Option } = Select;

const ManageGroupSelect = ({
  value,
  onChange,
  parentBranch,
  onManageGroupChange,
  showTitle = true
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');

  const fetchManageGroups = async (search = '') => {
    setLoading(true);
    try {
      const response = await apiGetCategory({
        keyword: search === '' ? undefined : search,
        type: 'KV',
        parent_level_1_id: parentBranch ?? undefined
      });
      setOptions(
        response.data?.data
          ?.map((item) => ({
            label: item.name,
            value: item.value
          }))
          .sort((a, b) => a?.label?.localeCompare(b?.label, 'vi', { sensitivity: 'base' }))
      );
    } catch (error) {
      console.error('Error fetching manage group data:', error);
    } finally {
      setLoading(false);
    }
  };

  // Tạo debounced function với useCallback để tránh tạo lại function mỗi lần render
  const debouncedFetchManageGroups = useCallback(
    debounce((searchText) => {
      fetchManageGroups(searchText);
    }, 800),
    [parentBranch]
  );

  useEffect(() => {
    fetchManageGroups();
  }, [parentBranch]);

  const handleChange = (values) => {
    onChange(values);
    // Clear search text after selection
    if (searchText) {
      setSearchText('');
      fetchManageGroups();
    }
    if (onManageGroupChange) {
      onManageGroupChange(values);
    }
  };

  const handleSearch = (searchValue) => {
    setSearchText(searchValue);
    if (searchValue === '') {
      // Nếu xóa hết keyword, gọi API ngay lập tức
      fetchManageGroups();
    } else {
      debouncedFetchManageGroups(searchValue);
    }
  };

  return (
    <div style={{ marginBottom: '16px' }}>
      {showTitle && (
        <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500' }}>Khu vực</label>
      )}
      <Select
        mode="multiple"
        value={value || []}
        onChange={handleChange}
        placeholder="Chọn khu vực"
        style={{ width: '100%', height: '36px' }}
        showSearch
        filterOption={false}
        onSearch={handleSearch}
        searchValue={searchText}
        loading={loading}
        allowClear
        maxTagCount="responsive"
        //disabled={!parentBranch || parentBranch.length === 0}
      >
        {options.map((option) => (
          <Option key={option.value} value={option.value}>
            {option.label}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default ManageGroupSelect;
